import { Navbar } from "../components/Navbar";
import { Hero } from "../components/home/Hero";
import { EditorialMarquee } from "../components/home/EditorialMarquee";
import { Manifesto } from "../components/home/Manifesto";
import { Modules } from "../components/home/Modules";
import { Pricing } from "../components/home/Pricing";
import { Contact } from "../components/home/Contact";
import { Footer } from "../components/Footer";

export default function Home() {
  return (
    <div data-testid="home-page" className="bg-paper">
      <Navbar />
      <main>
        <Hero />
        <EditorialMarquee />
        <Manifesto />
        <Modules />
        <Pricing />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
